import React from 'react'
import PropTypes from 'prop-types'
import styles from '../../../../styles.scss'
import LayoutItem from './components/LayoutItem'

const Layout = (props) => {
    const layouts = ['default', 'left', 'right']

    const list = layouts.map(value => (
        <LayoutItem
            key={value}
            value={value}
            selected={value === props.value}
            label={props.labels[value]}
            save={props.save}
            showMessage={props.showMessage}
        />
    ))

    return <ul className={styles.layout}>{list}</ul>
}

Layout.propTypes = {
    labels: PropTypes.shape({
        default: PropTypes.string,
        left: PropTypes.string,
        right: PropTypes.string,
    }),
    value: PropTypes.string,
    save: PropTypes.func,
    showMessage: PropTypes.func,
}

export default Layout



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/Layout/component.js